import styled from 'styled-components';

import { Label } from '@xing-com/label';
import { spaceS } from '@xing-com/tokens';

export const CheckboxItemContainer = styled(Label)`
  gap: ${spaceS};
  cursor: pointer;
`;
